export var UNWANTED_TAGS = ['br', 'hr', 'style'];
export var HEAD_TAGS = ['meta', 'link', 'title'];
export var HEADER_TAGS = ['h1', 'h2', 'h3', 'h4'];
export var BOLD_TAGS = ['bold', 'strong', 'b'];
export var OTHER_TEXT_TAGS = ['p', 'small', 'label', 'em', 'i'];
export var ALL_TEXT_TAGS = [].concat(HEADER_TAGS, BOLD_TAGS, OTHER_TEXT_TAGS);